import { Swiper } from 'swiper';
import 'swiper/css';

export default function () {
    const swiperElements = document.querySelectorAll('.our-mission__swiper');
    if (swiperElements.length > 0) {
        swiperElements.forEach(initSwiper);
    }
}

const initSwiper = (swiperElement) => {
    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

    let args = {
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true,
        enabled: true,
        breakpoints: {
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                enabled: true,
            },
            1024: {
                grabCursor: slideCount > 4,
                enabled: slideCount > 4,
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    };

    const swiper = new Swiper(swiperElement, args);
};
